


import { createSlice } from "@reduxjs/toolkit";

const registrationJourneySlice = createSlice({
    name: 'registrationJourney',
    initialState: {},
    reducers: {
        updateRegistrationJourneyStep: (state, action): any => {
            const newState = action.payload
            return newState
        },
    },
});
export const { updateRegistrationJourneyStep } = registrationJourneySlice.actions;
export default registrationJourneySlice.reducer;